(function() { module.exports = window["maplibregl"]; }());